import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { SummaryCard } from "./SummaryCard";
import { Icon } from "../../foundations/icons/Icon/Icon";
import { Text } from "../../foundations/typography/Text";
import { Link } from "../link/Link";

export interface SummaryCardSkipSectionProps {
  testID?: string;
  sectionEditUrl?: string;
  sectionTitle: string;
  title: string;
  reason?: string;
}

export function SummaryCardSkipSection({
  testID = "summary-card-skip-verification",
  sectionEditUrl,
  reason,
  title,
  sectionTitle,
}: SummaryCardSkipSectionProps) {
  const { t } = useTranslation();

  return (
    <SummaryCard
      header={sectionTitle}
      testID={testID}
      actions={
        sectionEditUrl && (
          <Link
            href={sectionEditUrl}
            textColor="text-weak"
            testID={`${testID}-edit-button`}
          >
            {t("Edit")}
          </Link>
        )
      }
    >
      <div className={css(styles.skippedContainer)}>
        <div className={styles.skippedIcon}>
          <Icon name="warning" color="icon-warning" />
        </div>
        <div className={styles.skippedTextContainer}>
          <Text
            style="global/heading-small"
            color="text-base"
            className={styles.skippedTextPadding}
          >
            {title}
          </Text>
          {reason && (
            <Text style="form/list-secondary" color="text-base">
              {reason}
            </Text>
          )}
        </div>
      </div>
    </SummaryCard>
  );
}

const styles = {
  skippedContainer: css({
    padding: "var(--space-4)",
    display: "flex",
    flexDirection: "row",
    backgroundColor: "var(--background-warning-weak)",
  }),
  skippedIcon: css({
    paddingRight: "var(--space-2)",
  }),
  skippedTextContainer: css({ display: "flex", flexDirection: "column" }),
  skippedTextPadding: css({ paddingBottom: "var(--space-1)" }),
};
